var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-switch',{staticClass:"mx-2",attrs:{"disabled":_vm.disabled,"input-value":_vm.inputValue,"label":_vm.inputLabel},on:{"change":function($event){return _vm.$store.dispatch(_vm.storeAction)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }